/**
 * API configuration settings and URL utilities
 */

/** Base URL for all API requests */
const envApiUrl = process.env.REACT_APP_API_URL?.trim();

const isHttpsPage = () => typeof window !== 'undefined' && window.location.protocol === 'https:';

const isLocalHttpApiUrl = (apiUrl: string) => {
  try {
    const parsedUrl = new URL(apiUrl);
    const hostname = parsedUrl.hostname.toLowerCase();
    return parsedUrl.protocol === 'http:' && (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0' ||
      hostname === '[::1]' ||
      hostname === '::1' ||
      /^10\./.test(hostname) ||
      /^192\.168\./.test(hostname) ||
      /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname)
    );
  } catch {
    return false;
  }
};

const getDefaultApiBaseUrl = () => {
  if (isHttpsPage()) {
    return window.location.origin;
  }
  return 'http://localhost:8000';
};

const getApiBaseUrl = () => {
  if (envApiUrl && envApiUrl.length > 0) {
    if (isHttpsPage() && isLocalHttpApiUrl(envApiUrl)) {
      return window.location.origin;
    }
    return envApiUrl;
  }
  return getDefaultApiBaseUrl();
};

export const API_BASE_URL = getApiBaseUrl()
  .replace(/\/+$/, '');

/**
 * Constructs a full API URL from a path
 * @param path - The API endpoint path
 * @returns The complete API URL
 */
export const getApiUrl = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
};
